import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { DataImportModule } from '../data-import/data-import.module';
import { OrderUploadComponent } from './order-upload.component';

const routes: Routes = [
  { path: '', component: OrderUploadComponent, data: { title: 'Upload Order' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrderUploadRoutingModule {}

@NgModule({
  imports: [
    OrderUploadRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    DataImportModule,
  ],
  declarations: [OrderUploadComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OrderUploadModule {}
